export default __webpack_public_path__ + "static/grey-natural-cork-dadb7048717dc3fa764521542e75bc59.png";